import React from 'react';

function NiceMobile() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24.236'
      height='21.381'
      viewBox='0 0 24.236 21.381'
    >
      <g fill='#fff' data-name='Group 13440'>
        <path
          d='M7.891.02a7.713 7.713 0 017.442 7.888c0 1.991.007 3.982-.005 5.973a1.315 1.315 0 01-.7 1.266 1.654 1.654 0 01-2.528-1.563c-.29-2.978 1-7.237-1.6-9.317-2-1.686-4.839-.82-7.244-1.021v16.551C3.464 21.723.194 21.96 0 20.1V1.311A1.327 1.327 0 011.058.1C3.317-.106 5.619.082 7.891.02'
          data-name='Path 604'
        />
        <path
          d='M46.465 45.237V34.472a1.547 1.547 0 012.1-1.562 1.619 1.619 0 011.141 1.8v12.073a1.563 1.563 0 01-1.955 1.644c-1.933 0-3.865.01-5.8 0a7.707 7.707 0 01-7.219-5.236 7.33 7.33 0 01-.368-2.3c.059-2.253-.131-4.536.084-6.775.243-.976 1.426-1.113 2.252-.859 1.964.349.145 7.565 1.3 9.384 1.462 3.406 5.483 2.494 8.466 2.6'
          data-name='Path 605'
          transform='translate(-28.311 -27.071)'
        />
        <path
          d='M95.925 2.112l-.648.647a5.484 5.484 0 00-7.674 0l-.643-.644a6.338 6.338 0 018.966 0'
          data-name='Path 606'
          transform='translate(-71.689 -.212)'
        />
        <path
          d='M100.7 12.021l-.648.651a3.606 3.606 0 00-5.069.006l-.643-.644a4.487 4.487 0 016.361-.014'
          data-name='Path 607'
          transform='translate(-77.775 -8.826)'
        />
        <path
          d='M105.578 21.933l-.648.647a1.789 1.789 0 00-2.458 0l-.643-.643a2.646 2.646 0 013.75 0'
          data-name='Path 608'
          transform='translate(-83.947 -17.44)'
        />
      </g>
    </svg>
  );
}

export default NiceMobile;
